import { render, staticRenderFns } from "./approvalFooter.vue?vue&type=template&id=0694309c&scoped=true"
import script from "./approvalFooter.vue?vue&type=script&lang=js"
export * from "./approvalFooter.vue?vue&type=script&lang=js"
import style0 from "./approvalFooter.vue?vue&type=style&index=0&id=0694309c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0694309c",
  null
  
)

export default component.exports